import React from "react";
import styled from "styled-components";
import { Swatch } from "../Legend/Legend";
import { fmtN } from "../../../functions/format";

/**
 * Légende tabulaire : couleur, libellé, valeur, pourcentage.
 * rows : [{ name, value, color }], total pour le calcul du %.
 */
const LegendTable = ({ rows = [], total }) => {
    return (
        <Wrapper>
            {rows.map((row) => (
                <Row key={row.name}>
                    <Swatch style={{ background: row.color }} />
                    <Name>{row.name}</Name>
                    <Value>{fmtN(row.value)}</Value>
                    <Pct>{Math.round((row.value / total) * 100)}%</Pct>
                </Row>
            ))}
        </Wrapper>
    );
};

export default LegendTable;

const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
`;

const Row = styled.div`
    display: flex;
    align-items: center;
    gap: 9px;
    padding: 8px 0;
    border-bottom: 1px solid var(--prh-line);
    font-size: var(--prh-font-md);
`;

const Name = styled.span`
    flex: 1;
    color: var(--prh-muted);
`;

const Value = styled.span`
    font-weight: 600;
    color: var(--prh-ink);
`;

const Pct = styled.span`
    color: var(--prh-muted-2);
    width: 38px;
    text-align: right;
`;
